import { Action } from 'redux-actions';

/*
 * typescript is able to detect interface for action strictly
 * const myAction = () => createAction("MY_ACTION", () => {key: "val"})
 * if(actionEqual(action, myAction)) {
 *   // here `action` variable has myAction interface
 *   // so typescript knows `action.payload.key` is exists
 * }
 */
export const actionEqual = <T>(
  a1: { type: string },
  a2: (...params: any[]) => Action<T> | undefined
): a1 is { type: string; payload: T } => {
  return a1.type === String(a2);
};



// WEBPACK FOOTER //
// ./app/reducers/utils.ts